import React from 'react';

export default function ReactVideoBg ({vidSrc, muted, autoPlay, loop, opacity, backgroundColor}) {
  return (
    <div className="video-background">
      <video
          src={vidSrc}
          autoPlay={autoPlay}
          loop={loop}
          muted={muted}
          style={{
            opacity: opacity,
            backgroundColor: backgroundColor
          }}
        />
      <div className="video-foreground">
      </div>
    </div>
  );
}

ReactVideoBg.defaultProps = { 
  vidSrc: 'https://www.w3schools.com/html/mov_bbb.mp4',
  muted: true,
  autoPlay: true,
  loop: true,
  opacity: 0.9,
  backgroundColor: '#000'
}